import emoji from "react-easy-emoji";
import airbnb from "./assets/img/icons/common/airbnbLogo.png";
import github from "./assets/img/icons/common/github.svg";
import googlelogo from "./assets/img/icons/common/google.svg";


export const greetings = {
	name: "Digvijay Dheer",
	title: "Hello, I'm Digvijay",
	description: "I am a Creative web developer dedicated to building and optimizing the performance of user-centric, high-impact websites. Technical, analytical and problem-solving skills to create competitive advantage and revenue growth dynamically, high speed websites, apps and platforms.",
	// "A passionate Full Stack Web Developer and Mobile App Developer having an experience of building Web applications with JavaScript / Reactjs / Nodejs / Python / Django / Flask and some other cool libraries and frameworks and Cross Platform Mobile Apps With Flutter.",
	resumeLink: "https://drive.google.com/file/d/1GK5Mjd41fdZzHIo1Np7jSANrKXQzu-nO/view?usp=sharing",
};

export const openSource = {
	githubUserName: "DigvijayDheer",
};

export const contact = {};

export const socialLinks = {
	// gmail: "digvijaydheersaini@gmail.com",
	instagram: "https://www.instagram.com/dheerdigvijay/",
	twitter: "https://twitter.com/DheerDigvijay",
	github: "https://github.com/DigvijayDheer",
	linkedin: "https://linkedin.com/in/digvijay-dheer-a6440017b",
};

export const skillsSection = {
	title: "What Skills I have",
	subTitle:
		"I AM ENTHUSIASTIC ABOUT DEVELOPMENT FIELD WHO WANTS TO EXPLORE EVERY TECH STACK",
	skills: [
		emoji(
			"⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
		),
		// emoji(
		// 	"⚡ KnowledgeUser Interface Designing "
		// ),
		emoji(
			"⚡ Integration of third party services such as Firebase/ MongoDB / Netlify / Heroku etc."
		),
	],

	softwareSkills: [
		{
			skillName: "c",
			fontAwesomeClassname: "logos:c",
		},
		{
			skillName: "python",
			fontAwesomeClassname: "logos:python",
		},
		{
			skillName: "data-structure",
			fontAwesomeClassname: "carbon:data-structured",
		},
		{
			skillName: "html-5",
			fontAwesomeClassname: "vscode-icons:file-type-html",
		},
		{
			skillName: "css3",
			fontAwesomeClassname: "vscode-icons:file-type-css",
		},
		{
			skillName: "JavaScript",
			fontAwesomeClassname: "logos:javascript",
		},
		// {
		// 	skillName: "TypeScript",
		// 	fontAwesomeClassname: "logos:typescript-icon",
		// },
		{
			skillName: "reactjs",
			fontAwesomeClassname: "vscode-icons:file-type-reactjs",
		},
		{
			skillName: "redux",
			fontAwesomeClassname: "logos:redux",
		},
		{
			skillName: "nodejs",
			fontAwesomeClassname: "logos:nodejs-icon",
		},
		{
			skillName: "expressjs",
			fontAwesomeClassname: "logos:express",
		},
		{
			skillName: "electronjs",
			fontAwesomeClassname: "fontisto:electronjs",
		},
		// {
		// 	skillName: "flutter",
		// 	fontAwesomeClassname: "logos:flutter",
		// },
		// {
		// 	skillName: "swift",
		// 	fontAwesomeClassname: "vscode-icons:file-type-swift",
		// },
		{
			skillName: "npm",
			fontAwesomeClassname: "vscode-icons:file-type-npm",
		},
		// {
		// 	skillName: "sql-database",
		// 	fontAwesomeClassname: "vscode-icons:file-type-sql",
		// },
		{
			skillName: "mongoDB",
			fontAwesomeClassname: "vscode-icons:file-type-mongo",
		},
		// {
		// 	skillName: "aws",
		// 	fontAwesomeClassname: "logos:aws",
		// },
		{
			skillName: "firebase",
			fontAwesomeClassname: "logos:firebase",
		},
		{
			skillName: "git",
			fontAwesomeClassname: "logos:git-icon",
		},
		{
			skillName: "rest-api",
			fontAwesomeClassname: "dashicons:rest-api",
		},
		// {
		// 	skillName: "docker",
		// 	fontAwesomeClassname: "logos:docker-icon",
		// },
	],
};

export const SkillBars = [
	{
		Stack: "Frontend/Design", //Insert stack or technology you have experience in
		progressPercentage: "90", //Insert relative proficiency in percentage
	},
	{
		Stack: "Backend",
		progressPercentage: "70",
	},
	{
		Stack: "Programming",
		progressPercentage: "60",
	},
];

export const educationInfo = [
	{
		schoolName: "ABES Institute of Technology",
		subHeader: "Bachelor of Technology in Information Technology",
		duration: "2018 - 2022",
		desc: "Campus 2, 19th Km. Stone, NH 24, Ghaziabad, U.P. 201009, INDIA",
		descBullets: [
			"Completed my Engineering in Information Technology.",
			"Secured 7.77 CGPA with Distinction.",
		],
	},
	{
		schoolName: "L.J.P.S.V.M Inter College",
		subHeader: "Senior Secondary (XII)",
		duration: "2017 - 2018",
		desc: "Jansath Road Muzaffarnagar, U.P. 251001 INDIA",
		descBullets: [
			"Completed my Senior Secondary School in Science (PCM).",
			"Scored 70.4% and passed with 1st Division.",
		],
	},
	{
		schoolName: "L.J.P.S.V.M Inter College",
		subHeader: "Secondary (X)",
		duration: "2015 - 2016",
		desc: "Jansath Road Muzaffarnagar, U.P. 251001 INDIA",
		descBullets: [
			"Completed my Secondary School in Computer Science",
			"Scored 86% and saved rank in merit list.",
			"Took over the responsibility of Student Discipline Head.",
		],
	},
];

export const experience = [
	{
		role: "Software Engineer",
		company: "Google",
		companylogo: googlelogo,
		date: "June 2018 – Present",
		desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
		descBullets: [
			"Lorem ipsum dolor sit amet, consdfgectetur adipiscing elit",
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
		],
	},
	{
		role: "Front-End Developer",
		company: "Github",
		companylogo: github,
		date: "May 2017 – May 2018",
		desc: "Lorem ipsum dolor sit amet, consefdctetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
	},
	{
		role: "Software Engineer Intern",
		company: "Airbnb",
		companylogo: airbnb,
		date: "Jan 2015 – Sep 2015",
		desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
	},
];

export const projects = [
	{
		name: "Augmented Random Search For HalfCheetahEnvironment",
		desc: "It is an AI simulator to train an ML agent in an OpenAI engine without any ML library.",
		github: "https://github.com/DigvijayDheer/Augmented-Random-Search-for-Half-Cheetah-Environment",
	},
	{
		name: "Text Recognition System",
		desc: "Machine Learning software which can be used for capturing and document, for document management and text processing using Python and OCR Engine.",
		github: "https://github.com/DigvijayDheer/Text-Recognition-Using-Python-main",
	},
	{
		name: "Unboxed Mindz",
		desc: "Official Website of Unboxed Mindz.",
		link: "https://unboxedmindz.com/"
	},
	{
		name: "Constrosolution",
		desc: "MERN stack E-Commerce Web application with PayPal Payment Gateway.",
		github: "https://github.com/DigvijayDheer/constrosolution",
	},
	{
		name: "The Burger Builder App",
		desc: "Animated Burger building, ordering and fun Web application using React and Firebase",
		github: "https://github.com/DigvijayDheer/the-burger-builder-app",
		link: "https://the-burger-builder-84e90.web.app/"
	},
	{
		name: "Amazon Clone App ",
		desc: "The absolute clone of real amazon.com using React and Firebase",
		github: "https://github.com/DigvijayDheer/amazon-clone-app",
		link: "https://clone-app-9cc98.web.app/",
	},
];

export const feedbacks = [
	{
		name: "",
		feedback:
			"We have been very happy with our new website! It looks professional and very easy to navigate. Our experience with the customer service at has been great. They handle things very efficiently and are available for any questions we have. They also keep us updated on daily reports so we know how our site is doing. I would recommend that u have choose web developer services for u.",
	},
	{
		name: "Maheen Altaf",
		feedback:
			"the website is very nice, everything was perfectly made as i need. it just loads in moments, without giving u the chance to wait. the quality is also very amazing. i am using it without any problem. great job",
	},
];
